import type { ClientResponse, ProductPagedQueryResponse } from '@commercetools/platform-sdk';

import type { ApiClientDetails } from '../../types';

export function productApi({ apiRoot }: ApiClientDetails) {
    async function fetchProductsByOffset(
        limit: number,
        offset: number
    ): Promise<ClientResponse<ProductPagedQueryResponse>> {
        return apiRoot()
            .products()
            .get({
                queryArgs: {
                    limit,
                    offset,
                    expand: 'masterData.current.categories[*].ancestors[*]', // Expands ancestors for each category in the product data
                },
            })
            .execute();
    }

    return {
        fetchProductsByOffset,
    };
}
